import clsx from 'clsx';
import styles from '../../styles/components/atoms/Progress.module.scss';

interface ProgressProps {
  className?: string;
  value: number;
  animateIn?: boolean;
  light?: boolean;
  medium?: boolean;
  large?: boolean;
  disabled?: boolean;
}

export default function Progress(props: ProgressProps) {
  const { value, disabled, light, medium, large, animateIn, className } = props;
  const { progress } = styles;
  const h = large ? 'large' : medium ? 'medium' : 'small'; //small ? "small" : "";
  const classes = clsx(
    progress,
    { [styles[h]]: h },
    { [styles.dark]: !light },
    { [styles.disabled]: disabled },
    { [styles.complete]: value === 100 },
    { [styles.animateIn]: animateIn },
    className
  );

  return (
    <div className={classes}>
      <div style={{ width: `${value}%` }}></div>
    </div>
  );
}
